import {Provider} from "@angular/core";
import {TEST_MODULE_REGISTRY, TestModuleDefinition} from "../../../core/shared/test/data/test-harness.types";


const yeModuleEntry: TestModuleDefinition = {
    key: 'ye',
    label: 'Excoda Integration (ye)',
    components: [

    ]
}

export const YE_TEST_PROVIDERS: Provider[] = [
    {provide: TEST_MODULE_REGISTRY, useValue: yeModuleEntry, multi: true}
];